'use client'
import React, { Suspense, useState } from 'react';
import Button from '@/components/CommonComponent/button';
import styled from 'styled-components';
import Link from 'next/link';
import { motion, AnimatePresence } from "framer-motion";
import { FaMinus } from "react-icons/fa6";
import { GoPlus } from "react-icons/go";
import ServiceAccordion from './service-accordion';
const Index = ({ props }: any) => {
  // console.log('props of the growth section ', props)
  const [selectedServiceIndex, setSelectedServiceIndex] = useState(0);
  const handleServiceClick = (index: number) => {
    setSelectedServiceIndex(index);
  };
  return (
    <Suspense fallback={null}>
      <div className="bg-white xl:w-[95%] 2xl:w-[80%] mx-auto px-6 pt-12 lg:pt-16">
        <h2 className="text-homeblack text-center md:text-left font-bold text-3xl lg:text-4xl">
          {props?.title}
        </h2>
        <StyledWrapper>
          <div className="text-homeblack mt-3" dangerouslySetInnerHTML={{ __html: props?.subtitle }} />
      <ServiceAccordion card={props.card} />
        </StyledWrapper>
        {/* Mobile Accordion */}

        {/* Call to Action Button */}
        <div className="flex justify-center mt-8">
          <Link href="/get-a-free-quote">
            <Button content=" Get a Proposal" />
          </Link>
        </div>
      </div></Suspense>
  );
};
export default Index;
export const StyledWrapper = styled.div`
  ul {
    list-style: disc;
  }

  h1 {
    font-size: 32px !important;
    font-weight: 700;
    color: var(--homeblack) !important;
  }

  h2 {
    font-size: 26px !important;
  }

  h3{
    font-size: 22px !important;
    font-weight: 500 !important;
  }
  // p {
  //   font-size: 17px;
  //   font-weight: 400;
  //   color: #535353;
  // }
  ol,
  ul {
    padding-left: 1.5rem;
    list-style-type: disc;
    color: #535353;
    font-size: 17px !important;
  }

  ul li::marker {
    color: #1090d0;
    font-size: 23px;
  }

  table {
    margin-top: 26px;
    margin-bottom: 26px;
    color: #535353;
    width: 100%;
  }

  td {
    padding: 15px;
    color: #535353;
  }

 a {
   /* Default text color */
   /* Default font weight */
  text-decoration: underline; /* Underline the link */
  text-decoration-color: #1090d0; /* Set default underline color to blue */
  text-decoration-thickness: 2px; /* Set the thickness of the underline to 2px */
  text-underline-offset: 3px;
  text-underline-offset: 5px; /* Optional: adjust the distance of the underline from the text */
}

a:hover {
  text-decoration-color: #EF1649; /* Change underline color to pink on hover */
}
`;
